export default __webpack_public_path__ + "static/media/ai_governance_high_risk_ai_systems.08ad417e.svg";